import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router/";
import store from "./store";
import axios from "axios";
import "./interceptors";
import VueMask from "v-mask";
import VueConfirmDialog from "vue-confirm-dialog";
import JsonExcel from "vue-json-excel";
import VueDragResize from "vue-drag-resize";
import "vuetify/dist/vuetify.min.css";
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.config.productionTip = false;

Vue.component("vue-drag-resize", VueDragResize);
Vue.use(VueMask);
Vue.use(VueConfirmDialog);

Vue.component("vue-confirm-dialog", VueConfirmDialog.default);

Vue.use(require("vue-moment"));

Vue.config.productionTip = false;

Vue.component("downloadExcel", JsonExcel);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD_mc7z9qBvdl6ueGip9MUo74JZXXqftkA',
    libraries: 'places', 
  },
});

new Vue({
  vuetify,
  router,
  store,
  axios,
  render: (h) => h(App),
}).$mount("#app");
